import React, { useEffect, useState } from "react";
import { getAllActions } from "../../api/action";
import { useSelector } from "react-redux";
import SingleSelectDefault from "../SingleSelectDefault";
import { useTranslation } from "react-i18next";
import { getProjects } from "../../api/projects";

export const ProjectSelectBoxDefault = (props:any) => {
    const { value, manageSelect, isReadOnly } = props;
    const [optionList, setOptionList] = useState([]);
    const clubDetails = useSelector((state:any) => { return state.clubDetails });
    // const [selectedValue, setSelectedValue] = useState(value || '');
    const [t] = useTranslation();

    
    const manageChange = (event: any, valueTemp: any) => {
        if(valueTemp?.name && valueTemp.name.startsWith("create '")) {
        valueTemp.name = valueTemp.name.slice(8, -1);
        }
        // setSelectedValue(valueTemp?.name || '');
        manageSelect(valueTemp);
    };

    const fetchProjectList = async () => {
        const response = await getProjects({ archivedStatus: 0, clubId: clubDetails?.id });
        setOptionList(response);
    }

    useEffect(() => {
        optionList.length == 0 &&
        clubDetails && clubDetails?.id &&
        fetchProjectList();
    }, [value, clubDetails]);

    return(
        <SingleSelectDefault
        label={t('PROJECT_NAME')}
        optionList={optionList}
        handleChange={manageChange}
        value={value}
        isReadOnly={isReadOnly}
        />
    )
}